export default [
	{
		path: '/home',
		name: 'home',
		meta: { title: '首页', hidden: true },
		component: () => import('@/views/home/HomeView.vue')
	},
	{
		path: '/notFound',
		name: 'notFound',
		meta: { title: 'notFound', hidden: false },
		component: () => import('@/views/system/NotFound')
	},
	{
		path: '/roles/list',
		name: 'roles-list',
		meta: { title: '角色权限', hidden: false },
		component: () => import('@/views/system/RolesList')
	},
	{
		path: '/menu/list',
		name: 'menu-list',
		meta: { title: '菜单管理', hidden: false },
		component: () => import('@/views/system/MenuList')
	},
	{
		path: '/org/user',
		name: 'org-user',
		meta: { title: '组织用户', hidden: false },
		component: () => import('@/views/system/OrgUser')
	},
	{
		path: '/system/org',
		name: 'system-org',
		meta: { title: '部门组织', hidden: false, scene: 'org' },
		component: () => import('@/views/system/OrgUser')
	},
	{
		path: '/system/account',
		name: 'system-account',
		meta: { title: '系统账号', hidden: false, scene: 'account' },
		component: () => import('@/views/system/OrgUser')
	},
	{
		path: '/system/role-permission',
		name: 'system-role-permission',
		meta: { title: '角色权限', hidden: false, scene: 'permission' },
		component: () => import('@/views/system/RolesList')
	},
	{
		path: '/userCancel/review',
		name: 'user-cancel-review',
		meta: { title: '用户注销审核', hidden: false },
		component: () => import('@/views/system/UserCancelReview')
	},
	{
		path: '/companyCancel/review',
		name: 'company-cancel-review',
		meta: { title: '企业注销审核', hidden: false },
		component: () => import('@/views/system/CompanyCancelReview')
	},
	{
		path: '/agreement/list',
		name: 'agreement-list',
		meta: { title: '协议管理', hidden: false },
		component: () => import('@/views/system/AgreementList')
	},
	{
		path: '/system/agreement-center',
		name: 'agreement-center',
		meta: { title: '协议查阅', hidden: false },
		component: () => import('@/views/system/AgreementCenter')
	},
	{
		path: '/dict/list',
		name: 'dict-list',
		meta: { title: '数据字典', hidden: false, keepAlive: true },
		component: () => import('@/views/system/DictList')
	}
];
